import { isTerminalApiError } from '@omnea-app/legacy/utils/error-handling/isApiErrorOfType'

export const resolvePollingInterval = (error: unknown, interval: number | undefined): number | false =>
  isTerminalApiError(error) ? false : (interval ?? false)
